import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './List.module.css';
import PostsTable from 'containers/Log/PostsTables/PostsTable/PostsTable';
import { updateObject } from 'shared/utility';
import * as actions from 'store/actions';

class List extends Component {
  constructor(props) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.state = {
      // searchInput: '',
      postsPerQuery: 50,
      currentPage: 1,
      // morePostsAvailable: true,
      selectedSortColumn: this.props.selectedSortColumn,
      columns: {
        Files: {
          name: 'Image(s)',
          key: 'Files',
          default: true,
          required: false,
          selected: true,
          sortable: false,
          action: null,
          width: 134,
        },
        Type: {
          name: 'Type',
          key: 'Type',
          default: true,
          required: false,
          selected: true,
          direction: 'desc',
          sortable: true,
          width: 96,
        },
        Title: {
          name: 'Title',
          key: 'Title',
          default: true,
          required: false,
          selected: true,
          direction: 'desc',
          sortable: true,
          width: 165,
        },
        DateStart: {
          name: 'Timeline History',
          key: 'DateStart',
          default: true,
          required: false,
          selected: true,
          direction: 'desc',
          sortable: true,
        },
        User: {
          name: 'Author’s Name',
          key: 'User',
          default: true,
          required: false,
          selected: true,
          sortable: true,
          direction: 'desc',
        },
        Logs: {
          name: 'Log(s)',
          key: 'Logs',
          default: true,
          required: false,
          selected: true,
          direction: 'desc',
          sortable: false,
        },
        Desc: {
          name: 'About',
          key: 'Desc',
          default: true,
          required: false,
          selected: false,
          direction: 'desc',
          sortable: true,
        },
        Contributors: {
          name: 'Contributors',
          key: 'Contributors',
          default: true,
          required: false,
          selected: false,
          direction: 'desc',
          sortable: false,
        },
        DatePostUpdated: {
          name: 'Date Modified',
          key: 'DatePostUpdated',
          default: false,
          required: false,
          direction: 'desc',
          sortable: true,
        },
        DateCreated: {
          name: 'Date Added',
          key: 'DateCreated',
          default: false,
          required: false,
          selected: false,
          direction: 'desc',
          sortable: true,
        },
        Location: {
          name: 'Location',
          key: 'Location',
          default: false,
          required: false,
          selected: false,
          direction: 'desc',
          sortable: false,
        },
        Tags: {
          name: 'Tags',
          key: 'Tags',
          default: false,
          required: false,
          selected: false,
          direction: 'desc',
          sortable: false,
        },
      },
    };
  }

  componentDidMount() {
    // Fetch posts for selected logs unless the user is returning from viewing post detail
    // In case when user is returning from post detail, we want to persist the posts that had been previously loaded
    // are still loaded in state and accessible on page for scroll
    if (this.props.filters.logIds.length > 0 && !this.props.prevPostId) {
      this.props.handleLogFetch(1, null, true, true, true);
    }

    const columns = this.getSelectedColumnsFromLocalStorage();
    this.setState({ columns });
  }

  componentDidUpdate(prevProps) {
    // If user has toggled from one log to another
    // OR a user has edited/added/deleted a post
    // OR sort order or sort column has changed, fetch log
    // Or filters have been changed
    // fetch posts
    if (
      (this.props.submitted && !prevProps.submitted) ||
      (this.props.deleted && !prevProps.deleted) ||
      prevProps.sortColumns[this.props.selectedSortColumn].sortOrder !== this.props.sortColumns[this.props.selectedSortColumn].sortOrder ||
      prevProps.selectedSortColumn !== this.props.selectedSortColumn ||
      this.props.filters !== prevProps.filters
    ) {
      // In case that selected logs and/or filters have been changed or a navlink being clicked, we need to reset the page number to 1,
      // tell the app to scroll up to top of page and fetch log from start
      this.props.onUpdateScrollToTopOfChild(true);
      this.setState({ currentPage: 1 });
      this.props.handleLogFetch(1, null, true, true, true);
    }
  }

  handleKeyDown = (e) => {
    // hide column selector if esc key is hit
    if (e.keyCode === 27 && this.state.showColumnsSelector) {
      this.toggleColumnSelector();
    }
  };

  getSelectedColumnsFromLocalStorage = () => {
    const columns = { ...this.state.columns };
    const localStorageSelectedColumns = localStorage.getItem('selectedColumns') ? JSON.parse(localStorage.getItem('selectedColumns')) : null;
    if (localStorageSelectedColumns) {
      Object.entries(localStorageSelectedColumns).forEach((column) => {
        columns[column[0]] = updateObject(columns[column[0]], {
          selected: column[1].selected,
        });
      });
    }
    return columns;
  };

  handleSort = (sortParam) => {
    const sortDirection =
      this.state.columns[sortParam].direction !== null ? (this.state.columns[sortParam].direction === 'asc' ? 'desc' : 'asc') : 'asc';
    const sortBy = sortDirection === 'asc' ? `${sortParam}_REV` : sortParam;
    if (Object.keys(this.props.sortColumns).includes(sortParam)) {
      this.props.handleSortChange(sortParam, sortDirection);
    } else {
      this.props.handleLogFetch(1, sortBy, true, true, true);
    }
    const updatedSortColumns = updateObject(this.state.columns, {
      [sortParam]: updateObject(this.state.columns[sortParam], {
        direction: sortDirection,
      }),
    });
    this.setState({ columns: updatedSortColumns, selectedSortColumn: sortParam, currentPage: 1 });
  };

  handleColumnSelection = (columnKey) => {
    const columns = updateObject(this.state.columns, {
      [columnKey]: updateObject(this.state.columns[columnKey], {
        selected: !this.state.columns[columnKey].selected,
      }),
    });
    this.setState({ columns });
    localStorage.setItem('selectedColumns', JSON.stringify(columns));
  };

  restoreDefaultColumns = () => {
    const updatedColumns = { ...this.state.columns };
    Object.keys(this.state.columns).forEach((column) => {
      const columnObject = updatedColumns[column];
      columnObject.selected = !!columnObject.default;
      updatedColumns[column] = columnObject;
    });
    this.setState({ columns: updatedColumns });
    localStorage.setItem('selectedColumns', JSON.stringify(updatedColumns));
  };

  fetchMorePosts = () => {
    if (this.props.log.PostCount > this.props.log.Posts.length && !this.props.loading) {
      const sortBy =
        this.state.columns[this.state.selectedSortColumn].sortOrder === 'asc'
          ? `${this.state.selectedSortColumn}_REV`
          : this.state.selectedSortColumn;
      const updatedPageNumber = this.state.currentPage + 1;
      this.props.handleLogFetch(updatedPageNumber, sortBy, true, true, true);
      this.setState({ currentPage: updatedPageNumber });
    }
  };

  handleCurrentPageUpdate = (pageNum) => {
    this.setState({ currentPage: pageNum });
  };

  render = () => {
    // const columnsList = [
    //   'Files',
    //   'Type',
    //   'Title',
    //   'DateStart',
    //   'User',
    //   'Logs',
    //   'Desc',
    //   'Contributors',
    //   'DatePostUpdated',
    //   'DateCreated',
    //   'Location',
    //   'Tags',
    // ];

    const subscribedLogIds = this.props.postingAs.Logs ? this.props.postingAs.Logs.map((log) => log.Id) : [];

    return (
      <div className={classes.PostsListViewContainer}>
        <PostsTable
          posts={this.props.log.Posts}
          postingAs={this.props.postingAs}
          filters={this.props.filters}
          users={this.props.log.Users}
          initialPostsLoaded={this.props.log.LogIds !== null}
          loading={this.props.loading}
          clicked={this.props.handlePostSelect}
          handleSort={this.handleSort}
          postCount={this.props.log.PostCount}
          subscribedLogIds={subscribedLogIds}
          columns={this.state.columns}
          selectedSortColumn={this.state.selectedSortColumn}
          fetchMorePosts={this.fetchMorePosts}
          pageSize={this.state.postsPerQuery}
          reduxPageNumber={this.props.log.Page.PageNum}
          prevPostId={this.props.prevPostId}
          handleClearPrevPostId={this.props.handleClearPrevPostId}
          toggleColumnSelector={this.toggleColumnSelector}
          restoreDefaultColumns={this.restoreDefaultColumns}
          handleColumnSelection={this.handleColumnSelection}
          handleCurrentPageUpdate={this.handleCurrentPageUpdate}
        />
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    log: state.logs.currentLogs,
    error: state.logs.error,
    loading: state.logs.loading === true,
    postingAs: state.user.postingAs,
    submitted: state.post.submitted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInitPostForm: (postId, isDraft, isGift, redirectPath, UserId, isManagedUser) =>
      dispatch(actions.initPostFormStart(postId, isDraft, isGift, redirectPath, UserId, isManagedUser)),
    onDuplicatePost: (postId, isDraft, copyNumber) => dispatch(actions.duplicatePost(postId, isDraft, copyNumber)),
    onDeletePost: (postId) => dispatch(actions.deletePost(postId)),
    onUpdateScrollToTopOfChild: (scrollToTop) => dispatch(actions.updateScrollToTopOfChild(scrollToTop)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
